/* eslint-disable  */
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

// import HeaderLogo from '@/assets/images/icons/MFO White (transparent).png';
import HeaderLogo from '@/assets/images/icons/MFO-main-logo-White.svg';
import primaryCTA from '@/assets/images/icons/Primary CTA_Large.svg';
import downloadTheApp from '@/assets/images/icons/Primary-CTA_Large.svg';
import { useFeatureFlags } from '@/api/feature-flags';
import routes from '@/routes/routes.json';

// export const LandingFooter = () => {
//   return (
//     <footer className="footer">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-5">
//             <Link href="/" className="footer__logo">
//               <Image
//                 src={HeaderLogo}
//                 alt="Muthoot FinCorp ONE Logo White"
//               />
//             </Link>
//             <p className="text--white text--regular footer__desc">
//               Muthoot FinCorp ONE is an all-in-one digital financial platform
//               that makes getting a Gold Loan, buying Digital gold, and
//               exchanging forex simple and convenient.  As an SBU of Muthoot
//               FinCorp Limited, Muthoot FinCorp ONE is backed by a legacy
//               stretching back over 135 years, and the trust of more than 1 crore
//               customers.
//             </p>
//             {/* <div className="footer__appLink">
//               <p className="text--semi text--white footer__appLink-text">
//                 Download the app
//               </p>
//               {/* <div className="bottom">
//                 <a href="#">
//                   // todo
//                   <Image
//style={{ color: undefined }}
//                     className="img-fluid"
//                     src={PlayStore}
//                     alt="google play store"
//                   />
//                 </a>
//                 <a href="#">
//                   <Image
//style={{ color: undefined }} className="img-fluid" src={AppStore} alt="app store" />
//                 </a>
//               </div> */}
//             <div className="d-flex align-items-center mfo-dowload-app">
//               <Link
//                 target="_blank"
//                 href="https://play.google.com/store/apps/details?id=com.muthootfincorpone.superapp"
//               >
//                 <Image
//style={{ color: undefined }}
//                   className="img-fluid"
//                   src={downloadTheApp}
//                   alt="Google Play Store"
//                 />
//               </Link>
//             </div>
//           </div>
//           <div className="col-lg-6 offset-lg-1 dg-landing-footer">
//             <div className="row">
//               <div className="col-md-7">
//                 <div className="row">
//                   <div className="col-6 mobile-border">
//                     <div className="footer__menu">
//                       <p className="footer__menu__title text--bold text--white">
//                         Products
//                       </p>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/gold-loans"
//                       >
//                         Gold Loans
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/digital-gold"
//                       >
//                         eSwarna Digital Gold
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/forex"
//                       >
//                         Forex
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="col-6 mobile-border">
//                     <div className="footer__menu">
//                       <p className="footer__menu__title text--bold text--white">
//                         Muthoot FinCorp ONE
//                       </p>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/about-us"
//                       >
//                         About Us
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/careers"
//                       >
//                         Careers
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/privacy-policy"
//                       >
//                         Privacy Policy
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/terms-and-conditions"
//                       >
//                         Terms of Use
//                       </Link>
//                       {/* todo */}
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/help"
//                       >
//                         Help
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/regulatory-compliance"
//                       >
//                         Regulatory & compliance
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="/GRIEVANCE REDRESSAL POLICY _10 Apr 2023.pdf"
//                       >
//                         Grievance Policy
//                       </Link>
//                       {/* todo */}
//                       {/* <Link
//                         className="footer__menu__link text--regular"
//                         href="/blogs"
//                       >
//                         FAQs
//                       </Link>
//                         Blogs
//                       </Link> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-5">
//                 <div className="row">
//                   <div className="col-12 mobile-border">
//                     <div className="footer__menu">
//                       <p className="footer__menu__title text--bold text--white">
//                         Contact Us
//                       </p>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="tel:1800-102-1616"
//                       >
//                         1800-102-1616
//                       </Link>
//                       <Link
//                         className="footer__menu__link text--regular"
//                         href="mailto:customercare@muthoot.com"
//                       >
//                         customercare@muthoot.com
//                       </Link>
//                     </div>
//                   </div>
//                   <div className="col-12">
//                     <div className="footer__menu social">
//                       <p className="footer__menu__title text--bold text--white">
//                         Follow Us
//                       </p>
//                       <div className="footer__social">
//                         <Link
//                           className="footer__menu__link text--regular"
//                           href="https://www.facebook.com/muthootfincorpone"
//                           target="_blank"
//                         >
//                           <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               d="M11.9999 2C-0.398398 2.36316 -1.66282 19.7607 10.4294 22H11.9999H13.5705C25.6654 19.7586 24.3955 2.3619 11.9999 2Z"
//                               fill="white"
//                             />
//                             <path
//                               d="M13.5698 14.9696H15.9119L16.3576 12.0614H13.5698V10.174C13.5698 9.37844 13.9593 8.60286 15.2079 8.60286H16.4755V6.12686C13.761 5.63781 10.4997 5.78665 10.4287 9.84476V12.0614H7.87653V14.9696H10.4287C10.4287 14.9696 10.4287 22.0002 10.4287 22.0004H11.9993H13.5698V14.9696Z"
//                               fill="#083F8D"
//                             />
//                           </svg>
//                           <span className="sr-only">Facebook</span>
//                         </Link>
//                         <Link
//                           className="footer__menu__link text--regular"
//                           href="https://twitter.com/mflone_"
//                           target="_blank"
//                         >
//                           <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               fill-rule="evenodd"
//                               clip-rule="evenodd"
//                               d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.5858 9.58034C18.0739 9.52111 18.5506 9.38713 19 9.18287C18.6688 9.69057 18.2521 10.1337 17.7694 10.4916C17.7746 10.5995 17.7772 10.7082 17.7772 10.8177C17.7835 11.7626 17.6067 12.6994 17.257 13.5737C16.9073 14.4479 16.3916 15.2422 15.7401 15.9104C15.0885 16.5786 14.314 17.1074 13.4615 17.4661C12.609 17.8248 11.6955 18.0062 10.774 17.9998C9.43585 18.0012 8.12563 17.6073 7 16.8653C8.30165 17.0251 9.61205 16.6497 10.6444 15.8211C10.1308 15.811 9.63302 15.6366 9.22079 15.3222C8.80856 15.0078 8.50243 14.5691 8.3452 14.0676C8.49812 14.0971 8.65339 14.112 8.809 14.1119C9.02806 14.1124 9.24621 14.0828 9.4576 14.0239C8.90038 13.9084 8.39926 13.5989 8.03925 13.1477C7.67924 12.6966 7.4825 12.1316 7.4824 11.5486V11.5166C7.82448 11.7117 8.20716 11.82 8.5984 11.8323C8.07718 11.4752 7.70823 10.9279 7.56667 10.3017C7.4251 9.67555 7.52156 9.01758 7.8364 8.46176C8.45453 9.24157 9.22565 9.87938 10.0997 10.3338C10.9738 10.7882 11.9313 11.0491 12.91 11.0995C12.8678 10.9108 12.8467 10.7178 12.847 10.5242C12.8473 10.018 12.9959 9.52367 13.2735 9.10518C13.5511 8.68668 13.9449 8.36336 14.4038 8.17715C14.8628 7.99094 15.3657 7.95042 15.8474 8.06085C16.3291 8.17128 16.7673 8.42757 17.1052 8.79648C17.6567 8.68533 18.1856 8.47805 18.6688 8.18366C18.485 8.76857 18.1001 9.26498 17.5858 9.58034Z"
//                               fill="white"
//                             />
//                           </svg>
//                           <span className="sr-only">Twitter</span>
//                         </Link>
//                         <Link
//                           className="footer__menu__link text--regular"
//                           href="https://www.linkedin.com/company/muthootfincorpone"
//                           target="_blank"
//                         >
//                           <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               d="M11.999 2C10.0212 2.0002 8.08793 2.58686 6.44357 3.68579C4.79921 4.78473 3.51764 6.34658 2.76092 8.17386C2.0042 10.0011 1.80631 12.0118 2.19227 13.9515C2.57824 15.8913 3.53073 17.673 4.92929 19.0714C6.32786 20.4698 8.10969 21.4221 10.0495 21.8079C11.9893 22.1937 13.9999 21.9956 15.8271 21.2387C17.6543 20.4818 19.216 19.2001 20.3148 17.5556C21.4135 15.9111 22 13.9778 22 12C22 10.6867 21.7413 9.38625 21.2387 8.17293C20.7361 6.95961 19.9994 5.85718 19.0707 4.92858C18.142 3.99998 17.0395 3.2634 15.8261 2.76092C14.6128 2.25843 13.3123 1.99987 11.999 2ZM9.33086 16.8344H7.13506V9.74114H9.33086V16.8344ZM8.22272 8.81213C7.96338 8.81424 7.70925 8.73926 7.4926 8.59671C7.27594 8.45415 7.10651 8.25045 7.00581 8.01145C6.90511 7.77245 6.87767 7.50892 6.92699 7.25431C6.9763 6.99969 7.10014 6.76546 7.28279 6.58134C7.46545 6.39722 7.69867 6.27151 7.95289 6.22015C8.2071 6.1688 8.47084 6.19412 8.71064 6.29291C8.95044 6.39169 9.15549 6.55948 9.29978 6.77499C9.44406 6.9905 9.52107 7.24401 9.52104 7.50336C9.52237 7.84907 9.38635 8.18115 9.14288 8.42658C8.8994 8.67201 8.56842 8.81069 8.22272 8.81213ZM17.559 16.8344H15.374V13.1112C15.374 12.09 14.986 11.5198 14.1785 11.5198C13.2997 11.5198 12.8406 12.1135 12.8406 13.1112V16.8344H10.7348V9.74114H12.8406V10.6965C13.0655 10.3332 13.3805 10.0344 13.7551 9.829C14.1297 9.62365 14.5511 9.5188 14.9782 9.52465C16.4824 9.52465 17.559 10.443 17.559 12.343V16.8344Z"
//                               fill="white"
//                             />
//                           </svg>
//                           <span className="sr-only">Linked In</span>
//                         </Link>
//                         <Link
//                           className="footer__menu__link text--regular"
//                           href="https://www.instagram.com/muthootfincorpone"
//                           target="_blank"
//                         >
//                           <svg
//                             width="24"
//                             height="24"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               fill-rule="evenodd"
//                               clip-rule="evenodd"
//                               d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.52449 6.03572C10.1651 6.00714 10.3699 6 11.9988 6C13.6277 6 13.8325 6.00714 14.4755 6.03334C15.1161 6.06192 15.5519 6.16432 15.9329 6.31196C16.3258 6.46676 16.6616 6.67156 16.995 7.00496C17.3284 7.33835 17.5356 7.67175 17.688 8.06707C17.8356 8.45047 17.938 8.88627 17.9666 9.52449C17.9952 10.1651 18.0023 10.3675 18.0023 11.9988C18.0023 13.63 17.9952 13.8325 17.9666 14.4731C17.938 15.1137 17.8356 15.5495 17.688 15.9305C17.5332 16.3234 17.3284 16.6592 16.995 16.9926C16.6616 17.326 16.3282 17.5332 15.9329 17.6856C15.5495 17.8332 15.1137 17.9356 14.4755 17.9642C13.8349 17.9928 13.6324 17.9999 12.0012 17.9999C10.3699 17.9999 10.1675 17.9928 9.52688 17.9642C8.88627 17.9356 8.45048 17.8332 8.06945 17.6856C7.67652 17.5308 7.34074 17.326 7.00734 16.9926C6.67394 16.6592 6.46676 16.3258 6.31435 15.9305C6.1667 15.5471 6.0643 15.1113 6.03572 14.4731C6.00714 13.8325 6 13.6277 6 11.9988C6 10.3699 6.00714 10.1651 6.03572 9.52687C6.0643 8.88627 6.1667 8.45047 6.31435 8.06945C6.46914 7.67652 6.67394 7.34074 7.00734 7.00734C7.34074 6.67394 7.67413 6.46676 8.06945 6.31435C8.45048 6.1667 8.88627 6.0643 9.52449 6.03572ZM8.91797 12.0015C8.91797 10.2988 10.2992 8.91992 11.9995 8.91992C13.7022 8.91992 15.0811 10.2988 15.0811 12.0015C15.0811 13.7042 13.7022 15.083 11.9995 15.083C10.2968 15.083 8.91797 13.7042 8.91797 12.0015ZM9.99913 11.9991C9.99913 13.1041 10.8945 13.9995 11.9995 13.9995C13.1045 13.9995 13.9999 13.1041 13.9999 11.9991C13.9999 10.8941 13.1045 9.9987 11.9995 9.9987C10.8945 9.9987 9.99913 10.8941 9.99913 11.9991ZM15.2016 9.51455C15.5988 9.51455 15.9208 9.19255 15.9208 8.79536C15.9208 8.39816 15.5988 8.07617 15.2016 8.07617C14.8044 8.07617 14.4824 8.39816 14.4824 8.79536C14.4824 9.19255 14.8044 9.51455 15.2016 9.51455Z"
//                               fill="white"
//                             />
//                           </svg>
//                           <span className="sr-only">Instagram</span>
//                         </Link>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

export const LandingFooter = () => {
  const { featureFlags, isFlagsFetched } = useFeatureFlags();

  return (
    <footer className="footer">
      {/* <form id="LASRqst" name="LASRqst" method="post" action="https://eservices-test.nsdl.com/tplas-core-service/v1/public/LASRequest">
                  <input type="hidden" name="transactionType" value="TPL" />
                  <input type="hidden" name="requestor" value="MUTHOOT FINANCE LTD" />
                  <input type="hidden" name="requestorId" value="IN000042" />
                  <input type="hidden" name="requestReference" value="6352226323316890" />
                  <input type="hidden" name="requestTime" value="2024-05-20T15:50:39.09Z" />
                  <input type="hidden" name="orderReqDtls" value="TTziVrnTLeM4pMv0qJMwHFcuG3kZVGEumSbUVpyocvA8t9RnfUet/OYeFFoheW1fEehnVeqDB4Bv+WAeuGqWCu3OxVtApGyVYYk5NLLudsjzhB+JtMTGn02lhXoF/Zh4rGJEVO90qCO82bKdVbqHqXZh/ChyEuHtm+Rf8mEdgo3z07AX7q0A/k7J5kXaH85p316Px7HUCWsCpAx4LviltD0BnoaFzpZBkgrUr2aFIjc35aGyECh1ifC/PBObpyGBkgkXZb/yB8KFls8eSq/8pWY2GU5JNI9vaYWVAcLuy6DaMXW+fiinrJPNtc/qt7Oel+bs7sU9J5Q9mgNqlJsEy/YZkgGPXQMV6A3Xzh7e0pqypV6VIcoKomLyAv4BVaUbHoG/yg3VkuCsbBtsTkLAfyrOXhHdJ+wxENd3q7Rh4L8mp2QSuFhVVWHtgNHyF/W1Y+w+KULXKWltPknUeYsRCgq9pH0i/pxaKCWkNsu1pK3ShEJeJ5lEYugXrm46483fSQSdcJtYfeSIZ91cZ9QEar3cEDRKbs0yneyOwfE90+BWSg03FJ+xf71AqiZj1gGA7DuaO7DfNlDjs7FqlrgR1h6BMWMITCnrOQ1hgfZc8Z8=" />
                  <input type="hidden" name="digitalSignature" value="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" />
                  <input type='submit'form='LASRqst'/>
                </form>  */}
      <div className="container">
        <Link href="/" className="footer__logo" id="footer_logo">
          {/* todo */}
          <Image
            style={{ color: undefined }}
            // className="img-fluid mfo-logo-footer"
            src={HeaderLogo}
            alt="Muthoot FinCorp ONE Logo White"
          />
        </Link>
        <div className="row justify-between">
          <div className="col-lg-5">
            <p className="text--white text--regular footer__desc">
              Muthoot FinCorp ONE is an all-in-one digital financial platform
              that makes getting a Gold Loan, buying eSwarna Digital gold, and
              exchanging forex simple and convenient.  As an SBU of{' '}
              <a
                className="muthoot-link text--bold"
                href="https://www.muthootfincorp.com/"
              >
                Muthoot FinCorp Limited
              </a>
              , Muthoot FinCorp ONE is backed by a legacy stretching back over
              135 years, and the trust of more than 1 crore customers.
            </p>
            {/* <div className="footer__appLink">
              <p className="text--semi text--white footer__appLink-text">
                Download the app
              </p>
              {/* <div className="bottom">
                <a href="#">
                  // todo 
                  <Image 
style={{ color: undefined }}
                    className="img-fluid"
                    src={PlayStore}
                    alt="google play store"
                  />  
                </a>
                <a href="#">
                  <Image 
style={{ color: undefined }} className="img-fluid" src={AppStore} alt="app store" />
                </a>
              </div> */}
            <div className="d-flex align-items-center mfo-dowload-app">
              <Link
                target="_blank"
                href="https://qrco.de/mfone"
                id="footer_download"
              >
                <Image
                  style={{ color: undefined }}
                  className="img-fluid"
                  src={downloadTheApp}
                  alt="Google Play Store"
                />
              </Link>
            </div>
          </div>
          <div className="col-lg-6 dg-landing-footer footer_spacing">
            <div className="row">
              {/* <div className="col-md-8">
                <div className="row">
                  <div className="col-5 mobile-border">
                    <div className="footer__menu">
                      <p className="footer__menu__title text--bold text--white">
                        Products
                      </p>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/gold-loans"
                      >
                        Gold Loans
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/digital-gold"
                      >
                        eSwarna Digital Gold
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/forex"
                      >
                        Forex
                      </Link>
                    </div>
                  </div>
                  <div className="col-7 mobile-border">
                    <div className="footer__menu">
                      <p className="footer__menu__title text--bold text--white">
                        Muthoot FinCorp ONE
                      </p>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/about-us"
                      >
                        About Us
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/careers"
                      >
                        Careers
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/privacy-policy"
                      >
                        Privacy Policy
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/terms-and-conditions"
                      >
                        Terms of Use
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/help"
                      >
                        Help
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/regulatory-compliance"
                      >
                        Regulatory & compliance
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="/GRIEVANCE REDRESSAL POLICY _10 Apr 2023.pdf"
                      >
                        Grievance Policy
                      </Link>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-6 col-lg-3 mobile-border">
                <div className="footer__menu">
                  <p className="footer__menu__title text--bold text--white">
                    Products
                  </p>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/gold-loans"
                    id="footer_gold-loans"
                  >
                    Gold Loans
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href={routes.digitalGoldHome}
                    id="footer_digital-gold"
                  >
                    eSwarna Digital Gold
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/forex"
                    id="footer_forex"
                  >
                    Forex
                  </Link>
                  { featureFlags.release_rv && isFlagsFetched &&
                  <Link
                    className="footer__menu__link text--regular"
                    href="/pay-rent-using-credit-card"
                    id="bbps-footer"
                  >
                    Payments
                  </Link>
                  }
                  {featureFlags.release_ncd && isFlagsFetched && (
                    <Link
                      className="footer__menu__link text--regular"
                      href="/ncd"
                      id="footer_ncd"
                    >
                      NCD
                    </Link>
                  )}
                </div>
              </div>
              <div className="col-6 col-lg-5 mobile-border">
                <div className="footer__menu">
                  <p className="footer__menu__title text--bold text--white company_name">
                    Muthoot FinCorp ONE
                  </p>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/about-us"
                    id="footer_about-us"
                  >
                    About Us
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/careers"
                    id="footer_careers"
                  >
                    Careers
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/privacy-policy"
                    id="footer_privacy-policy"
                  >
                    Privacy Policy
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/terms-and-conditions"
                    id="footer_terms-use"
                  >
                    Terms of Use
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/partners"
                    id="footer_partners"
                  >
                    Our Partners
                  </Link>
                  {/* todo */}
                  <Link
                    className="footer__menu__link text--regular"
                    href="/help"
                    id="footer_pre-help"
                  >
                    Help
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/regulatory-compliance"
                    id="footer_regulatory"
                  >
                    Regulatory & Compliance
                  </Link>
                  <Link
                    className="footer__menu__link text--regular"
                    href="/GRIEVANCE_REDRESSAL_POLICY_10_Apr_2023.pdf"
                    id="footer_grievance"
                  >
                    Grievance Policy
                  </Link>
                  {/* todo */}
                  {/* <Link
                        className="footer__menu__link text--regular"
                        href="/blogs"
                      >
                        Blogs
                      </Link>
                        Blogs
                      </Link> */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="col-12 mobile-border">
                    <div className="footer__menu">
                      <p className="footer__menu__title text--bold text--white">
                        Contact Us
                      </p>
                      <Link
                        className="footer__menu__link text--regular"
                        href="tel:1800-102-1616"
                        id="footer_contact-number"
                      >
                        1800-102-1616
                      </Link>
                      <Link
                        className="footer__menu__link text--regular"
                        href="mailto:customercare@muthoot.com"
                        id="footer_mail-id"
                      >
                        customercare@muthoot.com
                      </Link>
                      <span className="footer__menu__link text--regular d-flex visit-mfl">
                        Visit:
                        <Link
                          className="footer__menu__link text--regular ml-1"
                          href="https://www.muthootfincorp.com"
                        >
                          www.muthootfincorp.com
                        </Link>
                      </span>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="footer__menu social">
                      <p className="footer__menu__title text--bold text--white">
                        Follow Us
                      </p>
                      <div className="footer__social">
                        <Link
                          className="footer__menu__link text--regular"
                          href="https://www.facebook.com/muthootfincorpone"
                          target="_blank"
                          id="footer_facebook"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.9999 2C-0.398398 2.36316 -1.66282 19.7607 10.4294 22H11.9999H13.5705C25.6654 19.7586 24.3955 2.3619 11.9999 2Z"
                              fill="white"
                            />
                            <path
                              d="M13.5698 14.9696H15.9119L16.3576 12.0614H13.5698V10.174C13.5698 9.37844 13.9593 8.60286 15.2079 8.60286H16.4755V6.12686C13.761 5.63781 10.4997 5.78665 10.4287 9.84476V12.0614H7.87653V14.9696H10.4287C10.4287 14.9696 10.4287 22.0002 10.4287 22.0004H11.9993H13.5698V14.9696Z"
                              fill="#083F8D"
                            />
                          </svg>
                          <span className="sr-only">Facebook</span>
                        </Link>
                        <Link
                          className="footer__menu__link text--regular"
                          href="https://twitter.com/mflone_"
                          target="_blank"
                          id="footer_twitter"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6.5239 6.06274L5 6L5.88073 7.2452L9.77887 12.7565L5.99317 17.3121L7.36316 17.353L10.441 13.6927L12.7338 16.9342L12.958 17.2512H13.3461H16.6493H18.0854L17.2648 16.0726L13.3479 10.4473L17.0775 6.08184L15.613 6.08128L12.6793 9.48719L10.6189 6.52807L10.4062 6.22259L10.0343 6.20727L6.5239 6.06274ZM13.7343 15.7512L7.9861 7.62422L9.60062 7.69069L15.2132 15.7512H13.7343Z"
                              fill="#083F8D"
                            />
                          </svg>

                          <span className="sr-only">Twitter</span>
                        </Link>
                        <Link
                          className="footer__menu__link text--regular"
                          href="https://www.linkedin.com/company/muthootfincorpone"
                          target="_blank"
                          id="footer_linkedIn"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.999 2C10.0212 2.0002 8.08793 2.58686 6.44357 3.68579C4.79921 4.78473 3.51764 6.34658 2.76092 8.17386C2.0042 10.0011 1.80631 12.0118 2.19227 13.9515C2.57824 15.8913 3.53073 17.673 4.92929 19.0714C6.32786 20.4698 8.10969 21.4221 10.0495 21.8079C11.9893 22.1937 13.9999 21.9956 15.8271 21.2387C17.6543 20.4818 19.216 19.2001 20.3148 17.5556C21.4135 15.9111 22 13.9778 22 12C22 10.6867 21.7413 9.38625 21.2387 8.17293C20.7361 6.95961 19.9994 5.85718 19.0707 4.92858C18.142 3.99998 17.0395 3.2634 15.8261 2.76092C14.6128 2.25843 13.3123 1.99987 11.999 2ZM9.33086 16.8344H7.13506V9.74114H9.33086V16.8344ZM8.22272 8.81213C7.96338 8.81424 7.70925 8.73926 7.4926 8.59671C7.27594 8.45415 7.10651 8.25045 7.00581 8.01145C6.90511 7.77245 6.87767 7.50892 6.92699 7.25431C6.9763 6.99969 7.10014 6.76546 7.28279 6.58134C7.46545 6.39722 7.69867 6.27151 7.95289 6.22015C8.2071 6.1688 8.47084 6.19412 8.71064 6.29291C8.95044 6.39169 9.15549 6.55948 9.29978 6.77499C9.44406 6.9905 9.52107 7.24401 9.52104 7.50336C9.52237 7.84907 9.38635 8.18115 9.14288 8.42658C8.8994 8.67201 8.56842 8.81069 8.22272 8.81213ZM17.559 16.8344H15.374V13.1112C15.374 12.09 14.986 11.5198 14.1785 11.5198C13.2997 11.5198 12.8406 12.1135 12.8406 13.1112V16.8344H10.7348V9.74114H12.8406V10.6965C13.0655 10.3332 13.3805 10.0344 13.7551 9.829C14.1297 9.62365 14.5511 9.5188 14.9782 9.52465C16.4824 9.52465 17.559 10.443 17.559 12.343V16.8344Z"
                              fill="white"
                            />
                          </svg>
                          <span className="sr-only">Linked In</span>
                        </Link>
                        <Link
                          className="footer__menu__link text--regular"
                          href="https://www.instagram.com/muthootfincorpone"
                          target="_blank"
                          id="footer_instagram"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.52449 6.03572C10.1651 6.00714 10.3699 6 11.9988 6C13.6277 6 13.8325 6.00714 14.4755 6.03334C15.1161 6.06192 15.5519 6.16432 15.9329 6.31196C16.3258 6.46676 16.6616 6.67156 16.995 7.00496C17.3284 7.33835 17.5356 7.67175 17.688 8.06707C17.8356 8.45047 17.938 8.88627 17.9666 9.52449C17.9952 10.1651 18.0023 10.3675 18.0023 11.9988C18.0023 13.63 17.9952 13.8325 17.9666 14.4731C17.938 15.1137 17.8356 15.5495 17.688 15.9305C17.5332 16.3234 17.3284 16.6592 16.995 16.9926C16.6616 17.326 16.3282 17.5332 15.9329 17.6856C15.5495 17.8332 15.1137 17.9356 14.4755 17.9642C13.8349 17.9928 13.6324 17.9999 12.0012 17.9999C10.3699 17.9999 10.1675 17.9928 9.52688 17.9642C8.88627 17.9356 8.45048 17.8332 8.06945 17.6856C7.67652 17.5308 7.34074 17.326 7.00734 16.9926C6.67394 16.6592 6.46676 16.3258 6.31435 15.9305C6.1667 15.5471 6.0643 15.1113 6.03572 14.4731C6.00714 13.8325 6 13.6277 6 11.9988C6 10.3699 6.00714 10.1651 6.03572 9.52687C6.0643 8.88627 6.1667 8.45047 6.31435 8.06945C6.46914 7.67652 6.67394 7.34074 7.00734 7.00734C7.34074 6.67394 7.67413 6.46676 8.06945 6.31435C8.45048 6.1667 8.88627 6.0643 9.52449 6.03572ZM8.91797 12.0015C8.91797 10.2988 10.2992 8.91992 11.9995 8.91992C13.7022 8.91992 15.0811 10.2988 15.0811 12.0015C15.0811 13.7042 13.7022 15.083 11.9995 15.083C10.2968 15.083 8.91797 13.7042 8.91797 12.0015ZM9.99913 11.9991C9.99913 13.1041 10.8945 13.9995 11.9995 13.9995C13.1045 13.9995 13.9999 13.1041 13.9999 11.9991C13.9999 10.8941 13.1045 9.9987 11.9995 9.9987C10.8945 9.9987 9.99913 10.8941 9.99913 11.9991ZM15.2016 9.51455C15.5988 9.51455 15.9208 9.19255 15.9208 8.79536C15.9208 8.39816 15.5988 8.07617 15.2016 8.07617C14.8044 8.07617 14.4824 8.39816 14.4824 8.79536C14.4824 9.19255 14.8044 9.51455 15.2016 9.51455Z"
                              fill="white"
                            />
                          </svg>
                          <span className="sr-only">Instagram</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
